import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconOutlinedStar = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.6667 6.16004L9.87337 5.74671L8.00004 1.33337L6.12671 5.75337L1.33337 6.16004L4.97337 9.31337L3.88004 14L8.00004 11.5134L12.12 14L11.0334 9.31337L14.6667 6.16004ZM8.00004 10.2667L5.49337 11.78L6.16004 8.92671L3.94671 7.00671L6.86671 6.75337L8.00004 4.06671L9.14004 6.76004L12.06 7.01337L9.84671 8.93337L10.5134 11.7867L8.00004 10.2667Z",
		fill: "white"
	})
});
export default SvgIconOutlinedStar;
